import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "modal-content divers-modal" };
const _hoisted_2 = { class: "modal-header" };
const _hoisted_3 = { class: "modal-body" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = { class: "modal-footer" };
const _hoisted_7 = ["disabled"];
import { ref, onMounted, nextTick } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DiversItemModal',
    props: {
        visible: { type: Boolean }
    },
    emits: ["close", "confirm"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const itemName = ref('');
        const itemPrice = ref(0);
        const nameInput = ref(null);
        onMounted(() => {
            nextTick(() => {
                nameInput.value?.focus();
            });
        });
        const handleConfirm = () => {
            if (itemName.value && itemPrice.value > 0) {
                emit('confirm', {
                    name: itemName.value,
                    price: itemPrice.value,
                    isDiverse: true,
                });
                itemName.value = '';
                itemPrice.value = 0;
            }
        };
        return (_ctx, _cache) => {
            return (__props.visible)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "modal-overlay",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.$emit('close')), ["self"]))
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('pos.addCustomItem') || 'Ajouter un article divers'), 1),
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
                            }, "×")
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.name') || 'Nom de l\'article'), 1),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((itemName).value = $event)),
                                    type: "text",
                                    placeholder: "Ex: Frais de livraison, Dessert spécial...",
                                    class: "form-control",
                                    ref_key: "nameInput",
                                    ref: nameInput
                                }, null, 512), [
                                    [_vModelText, itemName.value]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("label", null, _toDisplayString(_ctx.$t('common.price') || 'Prix') + " (CHF)", 1),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((itemPrice).value = $event)),
                                    type: "number",
                                    step: "0.05",
                                    placeholder: "0.00",
                                    class: "form-control",
                                    onKeyup: _withKeys(handleConfirm, ["enter"])
                                }, null, 544), [
                                    [
                                        _vModelText,
                                        itemPrice.value,
                                        void 0,
                                        { number: true }
                                    ]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                                class: "btn-cancel",
                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('close')))
                            }, _toDisplayString(_ctx.$t('common.cancel') || 'Annuler'), 1),
                            _createElementVNode("button", {
                                class: "btn-confirm",
                                disabled: !itemName.value || itemPrice.value <= 0,
                                onClick: handleConfirm
                            }, _toDisplayString(_ctx.$t('common.add') || 'Ajouter au panier'), 9, _hoisted_7)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
